import React, { Component } from "react";
import {
  Breadcrumb,
  Container,
  Header,
  Menu,
  Message,
  Segment,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import moment from "moment";
import queryString from "query-string";
import { AutoSizer } from "react-virtualized";
import SimpleList from "../../lists/SimpleList";

class ReservationsView extends Component {
  constructor(props) {
    super(props);

    this.ReservationService = props.services.feathers.service(
      "api/reservations"
    );
  }

  componentDidMount() {}

  static mapDispatchToProps(dispatch) {
    return {
      dispatch,
      navigate: (path) => dispatch(push(path)),
    };
  }

  static mapStateToProps(state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS(),
    };
  }

  render() {
    const { t, authentication } = this.props;

    let query = queryString.parse(this.props.location.search);

    return (
      <AutoSizer disableHeight style={{ display: "flex", flex: 1 }}>
        {({ width }) => {
          let Wrapper = Container;
          let style = {};

          if (width < 764) {
            Wrapper = "div";
            style = {
              margin: 0,
              width,
            };
          }

          return (
            <Wrapper style={style}>
              {width >= 764 && (
                <Menu
                  inverted
                  style={{
                    backgroundColor: "#136444",
                    borderRadius: 0,
                    margin: 0,
                  }}
                >
                  <Menu.Item
                    as={Link}
                    name="inicio"
                    active={false}
                    to="/dashboard"
                  />
                  <Menu.Item name="mis reservas" active={true} />
                  <Menu.Item
                    as={Link}
                    name="mi saldo"
                    active={false}
                    to="/balance"
                  />
                </Menu>
              )}

              <Segment vertical secondary style={{ padding: 4 }}>
                <Breadcrumb>
                  <Breadcrumb.Section as={Link} link to={"/dashboard"}>
                    Inicio
                  </Breadcrumb.Section>
                  <Breadcrumb.Divider icon="right angle" />
                  <Breadcrumb.Section active>Reservas</Breadcrumb.Section>
                </Breadcrumb>
              </Segment>

              <Segment vertical>
                <Header as="h3">
                  <Header.Content>
                    MIS RESERVAS
                    <Header.Subheader>
                      Reservas realizadas previamente
                    </Header.Subheader>
                  </Header.Content>
                </Header>
              </Segment>

              {query.success && (
                <Message positive>
                  <Message.Header>Exito!</Message.Header>
                  <p>Reserva Confirmada!</p>
                </Message>
              )}

              <SimpleList
                header="Mis Reservas"
                subheader="Reservas pendientes y realizadas"
                service={this.ReservationService}
                findParams={{
                  query: {
                    $limit: 20,
                    SocioId: authentication.user.SocioId,
                  },
                }}
                mappingFunc={(reservation) => ({
                  header: `${reservation.concepto} ${reservation.cancha}`,
                  description: moment(reservation.fecha)
                    .parseZone()
                    .format("DD/MM/YYYY HH:mm"),
                  link: `/reservations/${reservation.id}`,
                  icon: moment(reservation.fecha).parseZone().isBefore(moment())
                    ? "check circle"
                    : "radio",
                  iconColor: moment(reservation.fecha)
                    .parseZone()
                    .isBefore(moment())
                    ? "green"
                    : "black",
                })}
                expandLink="/reservations"
              />
            </Wrapper>
          );
        }}
      </AutoSizer>
    );
  }
}

const i18nEnhancement = translate("translations")(ReservationsView);

export default connect(
  ReservationsView.mapStateToProps,
  ReservationsView.mapDispatchToProps
)(i18nEnhancement);



// WEBPACK FOOTER //
// ./src/components/views/reservations/ReservationsView.jsx